var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.595,
    height: 10.595,
    viewBox: "0 0 10.595 10.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fastright",
    d: "M6.111,4.832a.609.609,0,0,1,.2.46.642.642,0,0,1-.2.471L1.445,10.4a.648.648,0,0,1-.476.2.648.648,0,0,1-.476-.2l-.279-.279a.609.609,0,0,1-.2-.46.642.642,0,0,1,.2-.471L4.135,5.3.213,1.407a.642.642,0,0,1-.2-.471.642.642,0,0,1,.2-.471L.493.2A.648.648,0,0,1,.969,0a.648.648,0,0,1,.476.2ZM4.518,10.119a.609.609,0,0,1-.2-.46.642.642,0,0,1,.2-.471L8.439,5.3,4.518,1.407a.642.642,0,0,1-.2-.471.642.642,0,0,1,.2-.471L4.8.2a.662.662,0,0,1,.942,0l4.677,4.635a.609.609,0,0,1,.2.46.642.642,0,0,1-.2.471L5.739,10.4a.662.662,0,0,1-.942,0Z",
    transform: "translate(-0.017)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistDetails);
export default __webpack_public_path__ + "static/media/ChecklistDetails.2f024cf82ba287f4445f1484e32ecbe6.svg";
export { ForwardRef as ReactComponent };